import {IWspUiEnv, JWspDefProps, WSP} from "/@lib@/wsp/wsp.js";
import {IRegPointer} from "/@lib@/commons/registry.js";
import {WSP_DRV} from "/@lib@/wsp/drv.js";
import {JSrcFields} from "/@lib@/wsp/src.js";


export namespace WSP_L10N {

	export const WSP_PARAM_L10N = `${WSP.PARAM_custom_SC}l10n`;

	export function isL10n(props: JWspDefProps): boolean | undefined {
		if (!props) return undefined;
		return (props as any)[WSP_L10N.WSP_PARAM_L10N] || false;
	}

	/**
	 * Atelier master de la dérivation fournissant les contenus dans leur lanque naturelle
	 * @param props
	 */
	export async function findMasterWsp(props: IRegPointer<IWspUiEnv>, shortDesc: JSrcFields): Promise<string | undefined> {
		if (props.reg.getSvc("l10n/findMasterWsp"))
			return (props.reg.getSvc("l10n/findMasterWsp") as (props: IRegPointer<IWspUiEnv>, shortDesc: JSrcFields) => string | undefined)(props, shortDesc);
		else {
			const infoWsp = props.reg.env.wsp.infoWsp || props.reg.env.wsp.infoWspError;
			if (WSP_DRV.isDrv(infoWsp?.props)) {
				if (shortDesc.drvAxisDefCo === "")
					return infoWsp.props.drvMasterWsp;
				else if (!shortDesc.drvAxisDefCo)
					return null;
				else {
					const findPathWspCodeList = await WSP_DRV.getFindPathWspCodeList(props.reg.env.wsp, props.reg.env.uiRoot);
					return findPathWspCodeList[shortDesc.drvAxisDefCo];
				}
			}
			//FIXME evol : traiter le cas drf d'un drv AVEC l10n
		}
	}

	/**
	 * Atelier drv fournissant les contenus traduits
	 * NOTE : généralement l'atelier courant, sauf cas particulier DRF sur un DRV
	 * @param props
	 */
	export function findDrvWsp(props: IRegPointer<IWspUiEnv>): string | undefined {
		if (props.reg.getSvc("l10n/findDrvWsp"))
			return (props.reg.getSvc("l10n/findDrvWsp") as (props: IRegPointer<IWspUiEnv>) => string | undefined)(props);
		else {
			const infoWsp = props.reg.env.wsp.infoWsp || props.reg.env.wsp.infoWspError;
			if (WSP_DRV.isDrv(infoWsp?.props))
				return props.reg.env.wsp.code;
			//FIXME evol : traiter le cas drf d'un drv AVEC l10n
		}
	}

}
